module.exports = __webpack_public_path__ + "img/check_on.039d5c22.svg";